import AddNewCompanyForm from '../forms/AddNewCompanyForm/AddNewCompanyForm'


const AddNewCompany = () => {
	return (
		<>
			<AddNewCompanyForm />
		</>
	)
}

export default AddNewCompany
